import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "@redux/axios";

const API_URL = "/v1/blacklists";


export const FetchBlacklists = createAsyncThunk(
  "blacklists/fetchAll",
  async (data:any ={}, { rejectWithValue }) => {
    try {
        const res = await axios.get("/v1/blacklists", {
            headers: { "Content-Type": "application/json" },
            params: data,
          });
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const CreateBlacklist = createAsyncThunk(
  "blacklists/create",
  async (blacklistData, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, blacklistData);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
        return res.data;
      } catch (error) {
        return rejectWithValue(error);
      }
  }
);

export const UpdateBlacklist = createAsyncThunk(
  "blacklists/update",
  async ({ id, data }:any, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/${id}`, data);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
        return res.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const DeleteBlacklist = createAsyncThunk(
  "blacklists/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);